// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__gAlH_"};